import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1299,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'white',
    height: '100%',
    width: '100%',
    padding:0,
    overflow: 'hidden',
    fontFamily: 'Inter',
  },
  leftPart: {
    position: 'relative',
    zIndex: 1,
    background: 'linear-gradient(0deg, rgba(239, 251, 241, 0.00) 0%, rgba(239, 251, 241, 0.00) 100%)', /*theme.palette.primary.primary50*/
    boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.15)',
    height: '100%',
    width: '36%'
  },
  rightPart: {
    position: 'relative',
    background: '#F7F8FC',
    height: '100%',
    paddingBottom: '40px',
    width: '64%',
  },
  navigation: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '67px',
    height: '70px',
    borderBottom: `1px solid ${theme.palette.grey.grey300}`,
    cursor: 'pointer'
  },
  navigationText: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 600,
    color: theme.palette.grey.grey400
  },
  backArrow: {
    marginRight: '13px'
  },
  breadCrumb: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '70px',
    padding: '0px 45px',
    textAlign: 'center'
  },
  breadCrumbElement: {
    color: theme.palette.grey.grey500,
    cursor: 'pointer',
    fontSize: '14px',
    '&.selected': {
      color: theme.palette.primary.main,
    }
  },
  breadCrumbArrow:{
    margin: '0 14px'
  },
  leftContent: {
    padding: '45px',
    overflow: 'auto',
    height: '100%'
  },
  rightContent: {
    padding: '45px',
    overflowY: 'auto',
    height: '100%'
  },

}));

export default useStyles;
